import React from "react";
import { getClass } from "../utils/utils";
import { formatAmount } from "./ClientSummaryTable";

const ClientMonthlyTotals = ({ months, totalsByMonth }) => (
  <div className="client-table-scroll">
    <table className="table-total">
      <thead>
        <tr>{months.map((month) => <th key={month}>{month}</th>)}</tr>
      </thead>
      <tbody>
        <tr>
          {months.map((month) => {
            const value = totalsByMonth[month] || 0;
            return (
              <td key={month}>
                <div className={getClass(String(value))}>{formatAmount(value)}</div>
              </td>
            );
          })}
        </tr>
      </tbody>
    </table>
  </div>
);

export default ClientMonthlyTotals;
